@if(accApplicationDetails(); as accApp){
<div class="acc-application-overview-content-dialog-part row h-100">
	<div class="col-lg-6">
		<div class="bg-light rounded shadow-sm h-100">
			<div class="pt-2 ps-1">
				<h5>
					<span class="badge bg-secondary-subtle text-black px-3 py-2">
						Status: {{accApp.accApplicationStatus}}
					</span>
				</h5>
			</div>

			<div class="p-2 pt-0">
				<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border">
					<tbody>
						<tr>
							<td>Application Language</td>
							<td>{{accApp.language}}</td>
						</tr>
						<tr>
							<td>Video uploaded</td>
							<td>{{accApp.videoUploadedStatus}}</td>
						</tr>
						<tr>
							<td>Schedule Provided</td>
							<td>{{accApp.availMeetings ? 'Yes' : 'No'}}</td>
						</tr>
						<tr>
							<td>Available Meeting Times</td>
							<td>{{accApp.availMeetings ? accApp.availMeetings.numMeetings : 'Not Provided'}}</td>
						</tr>
					</tbody>
				</table>

				<div class="mt-2 p-left">
					<span>Available Class Times:</span>
					<ul class="mb-2">
						@for(time of accApp.availableMeetingTimes; track time) {
						<li>{{time}}</li>
						}
					</ul>
				</div>

				<div class="mb-3 p-left">
					<span>Seat Offered: {{accApp.seatfOfferedStatus}}</span>
				</div>

				<h5>Business Details</h5>
				<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border">
					<tbody>
						<tr>
							<td>Business Stage</td>
							<td>{{accApp.businessStageString}}</td>
						</tr>
						<tr>
							<td>Business Name</td>
							<td>{{accApp.ventureName}}</td>
						</tr>
						<tr>
							<td>Business Type</td>
							<td>{{accApp.businessType}}</td>
						</tr>
						<tr>
							<td>Industry</td>
							<td>{{accApp.industry}}</td>
						</tr>
						<tr>
							<td>Offerings</td>
							<td>{{accApp.offerings}}</td>
						</tr>
						@if(accApp.businessStage > 0 || accApp.annualRevenue){
						<tr>
							<td>Annual Revenue</td>
							<td>{{accApp.annualRevenue | currency:'USD':'symbol':'1.0-0'}}</td>
						</tr>
						}
						@if(accApp.businessStage > 0 || accApp.totalEmployees){
						<tr>
							<td>Total Employees</td>
							<td>{{accApp.totalEmployees}}</td>
						</tr>
						}
						<tr>
							<td>Website</td>
							<td>
								@if(websiteLink(); as link){
								<link-button [link]="link" />
								}
								@else {
								Not Provided
								}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>

	<div class="col-lg-6 ps-1">
		<div class="bg-light rounded shadow-sm h-100">
			<div class="pt-2 ps-1">
				<h5>
					<span class="badge bg-secondary-subtle text-black px-3 py-2">
						Participants
					</span>
				</h5>
			</div>

			<div class="p-2 pt-0">
				@if(accApp.participant; as applicant){
				<h5>Applicant: {{applicant.displayName}}
					<span class="ms-2 pointer" type="button" title="View Person"
						(click)="openPersonDialog(applicant.personId)">
						<i class="fa-regular fa-user"></i>
					</span>
				</h5>
				<ng-container
					*ngTemplateOutlet="participantDetails; context: { participant: applicant }"></ng-container>
				}

				@for (coParticipant of accApp.coParticipants; track coParticipant.personId) {
				<div class="mt-4">
					<h5>Co-Participant: {{coParticipant.displayName}}
						<span class="ms-2 pointer" type="button" title="View Person"
							(click)="openPersonDialog(coParticipant.personId)">
							<i class="fa-regular fa-user"></i>
						</span>
					</h5>
					<p>Status: Accepted</p>
					<ng-container
						*ngTemplateOutlet="participantDetails; context: { participant: coParticipant }"></ng-container>
				</div>
				}

				@for (invitedParticipant of accApp.invitedParticipants; let i = $index; track i) {
				<div class="mt-4">
					<h5>Co-Participant: {{invitedParticipant.displayName}} </h5>
					<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border">
						<tbody>
							<tr>
								<td>Status</td>
								<td>Not Accepted</td>
							</tr>
							<tr>
								<td>Invite Code</td>
								<td>{{invitedParticipant.formattedInviteCode}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				}
			</div>

		</div>
	</div>
</div>
}

<ng-template #participantDetails let-participant="participant">
	<div class="row">
		<div class="col-md-9">
			<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border">
				<tbody>
					<tr>
						<td>Video uploaded</td>
						<td>
							@if (participant.formattedVideoUploadedUTC) {
							{{participant.formattedVideoUploadedUTC}}
							} @else if (participant.uniqueVideoId) {
							Yes
							} @else {
							No
							}
						</td>
					</tr>
					<tr>
						<td>Involvement status</td>
						<td>{{participant.involvementStatus}}</td>
					</tr>
					<tr>
						<td>Employment status</td>
						<td>{{participant.employmentStatus}}</td>
					</tr>
					<tr>
						<td>Location</td>
						<td>{{participant.cityAndState}}</td>
					</tr>
					<tr>
						<td>Email</td>
						<td>{{participant.email}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="col-md-3">
			<div class="me-4 align-self-center play-icon" [class.color-eforall-blue]="participant.uniqueVideoId"
				[class.disabled]="!participant.uniqueVideoId"
				(click)="openVideoDialog(participant.personId, participant.uniqueVideoId!)">
				<i class="fa-fw fa-circle-play fa-regular" [attr.role]="participant.uniqueVideoId ? 'button': ''"></i>
			</div>
		</div>
	</div>
</ng-template>